import { base44 } from "@/api/base44Client";

import { safeLocalStorage } from '@/lib/browserStorage';
export async function recordAudit(action, entity = "", recordId = "", details = {}) {
  try {
    const user = await base44.auth.me();
    const device = safeLocalStorage.getItem("drilllog_device_name") || "Unknown device";
    await base44.entities.AuditLog.create({
      user_id: user?.id || null,
      user_name: user?.full_name || user?.name || user?.email || "Unknown",
      action,
      entity,
      record_id: recordId || "",
      device,
      details,
      occurred_at: new Date().toISOString(),
    });
  } catch (error) {
    // Auditing must never block the user's primary operation.
    console.warn("[DrillLogPro] audit log skipped:", error?.message || error);
  }
}
